import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Alert } from '@bibliocommons/base-alerts';
import { Lock } from '@bibliocommons/base-icons';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { bibShape, shelfItemShape, ugcPrivateNoteShape } from '@bibliocommons/bc-prop-types';
import TextUGCEditor from '../TextUGCEditor';

import './PrivateNoteUGCEditor.scss';

const CHARACTER_LIMIT = 4000;

function renderPrivacyAlert() {
  return (<div className="private-note-alert">
    <Alert>
      <Lock />
      <p><FormattedMessage id="ugc_private_note_alert" /></p>
    </Alert>
  </div>);
}

export class PrivateNoteUGCEditor extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleTextChange', 'handleSave');

    this.state = {
      note: ''
    };
  }

  componentWillMount() {
    const { existingPrivateNote } = this.props;
    if (existingPrivateNote && existingPrivateNote.get('note')) {
      this.setState({
        note: existingPrivateNote.get('note')
      });
    }
  }

  handleTextChange(value) {
    this.setState({ note: value });
  }

  handleSave(callback) {
    const { bib, existingPrivateNote, privateNotesActions } = this.props;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const noteId = existingPrivateNote && existingPrivateNote.get('id');
    const note = this.state.note;
    const postSuccess = callback;

    if (noteId) {
      privateNotesActions.updatePrivateNote({
        note,
        metadataId,
        noteId,
        postSuccess
      });
    } else {
      privateNotesActions.addPrivateNote({
        note,
        metadataId,
        postSuccess
      });
    }
  }

  render() {
    const { bib, existingPrivateNote, privateNotesTransactions, shelfItem, shelfActions, shelfTransactions, handleClose, intl } = this.props;

    const noteId = existingPrivateNote && existingPrivateNote.get('id');
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const renderHeader = () => (<h2>{noteId ? <FormattedMessage id="my_private_note" /> : <FormattedMessage id="add_private_note" />}</h2>);
    const isSavingPrivateNote = noteId ? privateNotesTransactions.getIn([metadataId, noteId, 'isUpdating'], false) : privateNotesTransactions.getIn([metadataId, 'isAdding'], false);
    const placeholder = intl.formatMessage({ id: 'private_note_placeholder' });
    const textAreaLabel = <FormattedMessage id="private_note_editor_label" />;

    return (
      <TextUGCEditor
        bib={bib}
        characterLimit={CHARACTER_LIMIT}
        className="cp-private-note-ugc-editor"
        errorKey="privateNote"
        renderHeader={renderHeader}
        handleClose={handleClose}
        handleSave={this.handleSave}
        handleTextChange={this.handleTextChange}
        placeholder={placeholder}
        isSaving={isSavingPrivateNote}
        showPrivacyAlert={false}
        renderCustomPrivacyAlert={renderPrivacyAlert}
        shelfItem={shelfItem}
        shelfTransactions={shelfTransactions}
        shelfActions={shelfActions}
        textAreaLabel={textAreaLabel}
        text={this.state.note} />
    );
  }
}

PrivateNoteUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  existingPrivateNote: ugcPrivateNoteShape,
  shelfItem: shelfItemShape,
  handleClose: PropTypes.func.isRequired,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default injectIntl(PrivateNoteUGCEditor);



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/PrivateNoteUGCEditor/PrivateNoteUGCEditor.jsx